<div class="remove-profile-confirmation">
    <div class="cancel-btn">
        <i class="material-icons pointer" mat-dialog-close>cancel</i>
    </div>
    <div class="delete-img">
        <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 0 24 24" width="48px" fill="#535042">
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
        </svg>
    </div>

    <h1 matDialogTitle>Confirmation</h1>
    <span>Are you sure you want to remove the profile image? </span>

    <div class="remove-profile-confirmation-group">
        <button  mat-button class="btn-outlined" mat-dialog-close>No</button>
        <button mat-button class="btn-filled" [mat-dialog-close]="true">Yes</button>

    </div>
</div>